import * as e from "react";
const c = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "VI_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#VI_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "VI_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#VI_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.601 8.215c.242.138.387.49.387.49H13.9l.283-.49s-.283-.128-.14-.128c.141 0 .546-.568.546-.568h-.169s-.087-.141.17-.141c.255 0 .46-.915.46-.915s.167-.428-.244-.536c-.41-.107-.906.358-.906.358s.121-.745.283-.906c.075-.075.215-.087.343-.098.148-.013.28-.024.28-.129 0-.196.482-.348 1.268-.348s1.072.939 1.072 1.123c0 .185.269 1.166.269 1.166s-.269 0-.269.126c0 .127.842.673.842.673s-.629.186-.387.323zM2.776 4.87c.314-.134 3.501.816 5.889 1.527 1.373.41 2.482.74 2.627.74.399 0 1.148.965.774 1.37-.375.407-.502.644-.251.644.25 0 1.516-.328 1.516-.328v3.772s-1.213.288-1.516 0c-.147-.14-.372-.148-.564-.155-.204-.008-.373-.014-.373-.176 0-.313-.698-.363-.698-.363s-.647-.213-.647-.414c0-.2-.423-.767-.423-.767s-1.613-.914-2.984-1.916c-.277-.202-.551-.393-.813-.575-1.036-.721-1.89-1.316-2.043-2.005-.716-.71-.988-1.142-.494-1.354zm10.066 7.962s-.543.374-1.143 1.376c-.296.493-.32.927-.337 1.241-.018.324-.028.52-.324.52-.345 0-.596.075-.8.136-.14.041-.258.077-.37.077-.273 0-.8 1.035-.537 1.274.264.24 1.366.621 1.366 0s.297-.974.836-.974c.539 0 1.502-.357 1.502-1.14 0-.783 1.05-.727 1.05-.727l-1.243-1.783zM23.56 6.397c2.387-.712 5.575-1.661 5.888-1.527.494.212.222.645-.494 1.354-.153.689-1.007 1.284-2.042 2.005-.262.182-.536.373-.813.575-1.371 1.002-2.984 1.916-2.984 1.916s-.423.567-.423.767c0 .2-.647.414-.647.414s-.699.05-.699.363c0 .162-.168.168-.373.176-.192.007-.416.015-.563.155-.304.288-1.516 0-1.516 0V8.823s1.265.328 1.516.328c.25 0 .124-.237-.25-.643-.376-.406.374-1.372.773-1.372.145 0 1.254-.33 2.627-.739zm-4.178 6.435s.543.374 1.144 1.376c.295.493.32.927.336 1.241.018.324.029.52.325.52.345 0 .595.075.8.136.14.041.257.077.369.077.274 0 .8 1.035.537 1.274-.263.24-1.366.621-1.366 0s-.296-.974-.835-.974c-.54 0-1.503-.357-1.503-1.14 0-.783-1.05-.727-1.05-.727l1.243-1.783zm-5.842 2.61c0-.344.61-.604.61-.604l1.834-.774.024.464.023-.464 1.835.774s.61.26.61.605c0 .173.259.478.518.783.257.304.514.607.514.777 0 .301-.696.978-1.116 1.387-.058.055-.11.106-.154.15-.097.096-.2.214-.309.336-.309.35-.651.738-.938.738-.202 0-.365.141-.521.276-.144.123-.282.242-.439.242-.008 0-.016-.004-.023-.011-.008.007-.015.011-.024.011-.156 0-.294-.119-.438-.242-.156-.135-.32-.276-.521-.276-.287 0-.63-.387-.939-.738-.108-.122-.212-.24-.308-.336a26.54 26.54 0 00-.154-.15c-.42-.409-1.116-1.086-1.116-1.387 0-.17.257-.473.514-.777.259-.305.518-.61.518-.783z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.009 10.673c.04.463.171.736.171.736s.231.364.363.368c.067.168.14.34.22.515.36.96.85 2.221 1.354 3.37a.8.8 0 00-.144-.081c-.42-.197-.722-.22-.722-.22s-.564.025-.506.185c.058.16.757.507 1.041.404l.095-.034c.131-.045.252-.087.285-.14l.2.446a2.292 2.292 0 00-.719-.218s-.564.024-.506.184c.059.16.758.508 1.042.404l.095-.033c.078-.027.153-.053.207-.081.507 1.08.996 1.943 1.346 2.161h.704s-.609-.86-1.376-2.065c.231-.164.554-.527.554-.756l.001-.1c.005-.267.008-.493-.284-.202a2.295 2.295 0 00-.453.604s-.015.049-.032.116l-.188-.302c.232-.162.56-.528.56-.758v-.101c.005-.266.009-.493-.283-.201-.329.328-.453.604-.453.604s-.016.048-.032.116a48.94 48.94 0 01-.267-.444c.226-.12.64-.55.64-.81l.001-.1c.005-.266.008-.493-.284-.201a2.293 2.293 0 00-.453.604s-.037.118-.06.244a40.22 40.22 0 01-.347-.606h.01c.17 0 .736-.537.736-.84l.002-.1c.004-.267.008-.493-.284-.202-.329.328-.453.605-.453.605s-.084.263-.075.421a30.73 30.73 0 01-.455-.847h.002c.17 0 .736-.538.736-.84L9 12.377c.005-.266.009-.493-.284-.202a2.295 2.295 0 00-.453.605s-.074.236-.075.396c-.153-.3-.296-.596-.425-.884-.07-.185-.134-.36-.193-.52a.064.064 0 00.023-.017c.11-.13.061-.91-.17-1.104a6.353 6.353 0 01-.077-.066c-.2-.174-.372-.323-.336.088zm.78 1.184s.023-.302.22-.722c.175-.374.249-.16.335.091l.034.096c.103.284-.244.983-.404 1.04-.16.06-.184-.505-.184-.505zm.79 2.889a2.295 2.295 0 00-.723-.22s-.564.025-.506.185c.059.16.758.507 1.042.404l.095-.034c.251-.086.466-.16.092-.335zM7.46 13.627s.303.023.723.22c.374.174.16.248-.092.335l-.095.033c-.284.104-.983-.244-1.041-.404-.058-.16.505-.184.505-.184zm.393-.68c-.42-.197-.723-.22-.723-.22s-.563.025-.505.185c.058.16.757.507 1.04.404l.096-.034c.252-.086.466-.16.092-.335zm-.88-1.302s.276.124.604.453c.291.292.065.288-.201.284l-.101-.002c-.302 0-.84-.565-.84-.735 0-.17.538 0 .538 0z",
      fill: "#46A000"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.69 10.339h-2.137s.453 0 .503.438c0 0 .01 3.694 0 3.984-.01.29-.503.389-.503.389s2.593.008 2.137 0c-.455-.008-.556-.39-.556-.39v-3.983c0-.338.556-.438.556-.438zM4.564 14.853c-.242-.624-1.736-4.449-1.736-4.449h1.479c-.257 0-.352.327-.352.327l1.035 2.954s1.002-2.412 1.002-2.839c0-.428-.42-.442-.42-.442h1.927l-.465.156S5.49 14.097 5.49 14.853c-.073.168.71.28.71.28h-2.07l.433-.28zm17.701-1.396l1.146-2.11.034 2.348-.355-.115-.252 1.568 1.267-2.43-.422-.158 1.569-1.698-.534 2.295-.304-.268-1.797 3.352 2.005-2.297-.386-.193 1.98-1.297-.862 2.113-.481-.346-2.035 2.561-.844-.324.844-3h-.573zm-.662 4.003h-.633v.482h-.499L19.06 19.58h.78l.27.923.362-.326v.326l.708-.326.677.586.505-2.253-.34-.25.175-.152-.175-.648h-.418z",
      fill: "#0093E1"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.342 8.014s.93.642 1.861.642c.93 0 1.861-.642 1.861-.642s.93.642 1.861.642c.931 0 1.862-.642 1.862-.642v2.9c0 3-3.723 5.325-3.723 5.325s-3.902-2.135-3.722-5.36V8.014z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "VI_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 12,
      y: 8,
      width: 8,
      height: 9
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.342 8.014s.93.642 1.861.642c.93 0 1.861-.642 1.861-.642s.93.642 1.861.642c.931 0 1.862-.642 1.862-.642v2.9c0 3-3.723 5.325-3.723 5.325s-3.902-2.135-3.722-5.36V8.014z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#VI_svg__c)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M12.078 7.821h7.84v3.02h-7.84v-3.02z", fill: "#2E42A5" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.594 10.84h-.659v6.105h.66v-6.104zm1.12 0h-.66v6.105h.66v-6.104zm.461 0h.66v6.105h-.66v-6.104zm1.779 0h-.66v6.105h.66v-6.104zm.462 0h.659v6.105h-.659v-6.104zm1.778 0h-.659v6.105h.659v-6.104z",
      fill: "#AF0100"
    }
  ))))
), s = c;
export {
  s as default
};
